/* eslint-disable react/prop-types */
import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

const AvatarUploader = ({ base64Image, setBase64Image, url }) => {
    // Convert file to base64
    const convertToBase64 = (file) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            setBase64Image({
                ...file,
                base64: reader.result
            })
        }
    }

    // Handle file drop
    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0]
        convertToBase64(file)
    }, [])

    // Dropzone setup
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpeg', '.png', '.jpg', '.gif']
        },
        multiple: false
    })

    return (
        <div className='flex flex-col items-start justify-start w-full'>
            <div
                {...getRootProps()}
                className={`w-48 h-48 border-2 border-dashed rounded-full flex items-center justify-center cursor-pointer ${
                    isDragActive ? 'border-blue-500' : 'border-gray-300'
                }`}
            >
                <input {...getInputProps()} />
                {base64Image ? (
                    <img src={base64Image?.base64} alt='' className='w-full h-full object-cover rounded-full' />
                ) :url ? (
                    <img src={url} alt='' className='w-full h-full object-cover rounded-full' />
                ) : (
                    <p className='text-gray-500 text-center'>{isDragActive ? 'Drop the file here...' : 'Drag & drop or click to upload'}</p>
                )}
            </div>
        </div>
    )
}

export default AvatarUploader
